// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2LGGu","inner":"Form_inner__3cc-V","range":"Form_range__Znyv_","name":"Form_name__J0BBW","actions":"Form_actions__3GPvY"};